var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function TrashIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 20.0004C7 20.0014 17.0016 20 17.0016 20C16.9996 20 16.9998 10.203 17 7H7V20.0004ZM19 20.0004C19 21.1047 18.1029 22 17.0016 22H6.99842C5.89472 22 5 21.1066 5 20.0004V7C4.44763 6.99953 4 6.55584 4 6C4 5.44772 4.44463 5 5.00087 5H10C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5H18.9991C19.5519 5 20 5.44386 20 6C20 6.552 19.5558 6.99953 19 7V20.0004ZM13 9.99754C13 9.44662 13.4439 9 14 9C14.5523 9 15 9.44631 15 9.99754V17.0025C15 17.5534 14.5561 18 14 18C13.4477 18 13 17.5537 13 17.0025V9.99754ZM9 9.99754C9 9.44662 9.44386 9 10 9C10.5523 9 11 9.44631 11 9.99754V17.0025C11 17.5534 10.5561 18 10 18C9.44772 18 9 17.5537 9 17.0025V9.99754Z", fill: "" })));
}
export var TrashIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: TrashIconInner }, props))); };
//# sourceMappingURL=TrashIcon.js.map